<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="webOffer && webOffer.id">{{ 'SALES.WEB_OFFERS_FORM.EDIT' | translate }}</span>
    <span *ngIf="!webOffer || !webOffer.id">{{ 'SALES.WEB_OFFERS_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<div class="scroll-wrapper modal-body">
  <form id="web-offers-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-9">
        <label>{{ 'SALES.WEB_OFFERS_FORM.TITLE' | translate }}</label>
        <input type="text" class="form-control" formControlName="title" />
      </div>

      <div class="col-sm-2 bg">
        <div
          class="sa-data-select-popover-trigger btn-link bg"
          [ngbPopover]="popSmtp"
          [autoClose]="false"
          triggers="manual"
          #smtpPopOver="ngbPopover"
          (click)="smtpPopOverOpen(smtpPopOver)"
          popoverClass="smtp-popover"
          container="body"
        >
          {{ 'SALES.WEB_OFFERS_FORM.SELECT' | translate }}
        </div>

        <ng-template #popSmtp>
          <div class="popover-wrapper">
            <div class="popover-custom-header d-flex align-items-center justify-content-between">
              <div class="popover-title">
                {{ 'SALES.WEB_OFFERS_FORM.SELECT_SMTP' | translate }}
              </div>

              <div>
                <button type="button" class="btn btn-danger btn-ico align-top mb-1" (click)="smtpPopOver.close()">
                  <i class="fal fa-times"></i>
                </button>
              </div>
            </div>

            <div *ngIf="saleAgentLoader" class="loader">
              <div class="spinner-border" role="status"></div>
            </div>
            <div *ngIf="!saleAgent">
              <strong class="mt-3 mb-3">{{ 'SALES.WEB_OFFERS_FORM.MISSING_SALES_AGENT_MSG' | translate }}</strong>
            </div>

            <form novalidate *ngIf="saleAgent">
              <ng-select
                class="mt-3"
                [items]="saleAgent.smtp_settings"
                bindLabel="nameAndEmail"
                [(ngModel)]="selectedSmtp"
                [ngModelOptions]="{ standalone: true }"
              >
              </ng-select>

              <button
                [disabled]="!selectedSmtp"
                class="btn btn-primary w-100 mt-3"
                type="button"
                (click)="setSmtp(smtpPopOver)"
              >
                {{ 'SALES.WEB_OFFERS_FORM.SET' | translate }}
              </button>
            </form>
          </div>
        </ng-template>

        <div class="row">
          <div class="col-sm-6">
            <label>{{ 'SALES.WEB_OFFERS_FORM.SALES_AGENT_NAMES' | translate }}</label>
            <input type="text" class="form-control" formControlName="sales_agent_names" />
          </div>

          <div class="col-sm-6">
            <label>{{ 'SALES.WEB_OFFERS_FORM.SALES_AGENT_EMAIL' | translate }}</label>
            <input type="text" class="form-control" formControlName="sales_agent_email" />
          </div>
        </div>
      </div>

      <div class="col-sm-1">
        <div class="custom-control custom-checkbox checkbox-margin">
          <input type="checkbox" class="custom-control-input" formControlName="active" id="web-offers-form-active" />
          <label class="custom-control-label" for="web-offers-form-active">
            {{ 'SALES.WEB_OFFERS_FORM.ACTIVE' | translate }}</label
          >
        </div>
      </div>

      <div class="col-sm-12">
        <div class="modal-section-title">{{ 'SALES.WEB_OFFERS_FORM.OFFERS' | translate }}</div>
        <kendo-grid
          #grid
          style="max-height: 400px"
          [columnMenu]="false"
          [data]="saleOffers"
          [kendoGridSelectBy]="'id'"
          [selectedKeys]="selectedSaleOffersIds"
          (selectionChange)="offersSelectionChange($event)"
        >
          <kendo-grid-checkbox-column
            [width]="32"
            [columnMenu]="false"
            showSelectAll="true"
            class="text-center"
            headerClass="text-center"
          >
          </kendo-grid-checkbox-column>

          <kendo-grid-column [width]="40" field="number" title="{{ 'SALES.WEB_OFFERS_FORM.NUMBER' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ rowIndex + 1 }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column field="name" title="{{ 'SALES.WEB_OFFERS_FORM.NAME' | translate }}"></kendo-grid-column>

          <ng-template kendoGridDetailTemplate let-dataItem>
            <kendo-grid style="max-height: 400px" [columnMenu]="false" [data]="dataItem.items">
              <kendo-grid-column
                [width]="60"
                class="text-center"
                headerClass="text-center"
                footerClass="fw-bold "
                field="offer_number"
                title="{{ 'SALES.SALES_VIEW.NUMBER' | translate }}"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ rowIndex + 1 }}
                </ng-template>

                <ng-template kendoGridFooterTemplate>
                  {{ 'SALES.SALES_VIEW.TOTALS' | translate }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                field="hotel.name"
                title="{{ 'SALES.SALES_VIEW.HOTEL' | translate }}"
                [columnMenu]="false"
                [width]="200"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div
                    class="d-inline-block text-truncate fw-bold"
                    style="max-width: 200px"
                    [ngbTooltip]="dataItem?.hotel?.name + '(' + dataItem?.hotel?.stars + ')'"
                    container="body"
                  >
                    <a [routerLink]="['/hotels/view']" [queryParams]="{ id: dataItem?.hotel?.id }">
                      {{ dataItem?.hotel?.name }}
                    </a>
                    <span *ngIf="dataItem.hotel?.stars">
                      {{ dataItem.hotel.stars }} <span class="star-ico-wrapper"><i class="fas fa-star"></i></span>
                    </span>
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                field="allotment.booking.note"
                title="{{ 'SALES.SALES_VIEW.BOOKING_NOTE' | translate }}"
                [columnMenu]="false"
                [width]="30"
              >
                <ng-template kendoGridHeaderTemplate>
                  <i class="fas fa-sticky-note"></i>
                </ng-template>

                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <span
                    *ngIf="dataItem?.allotment?.booking?.note"
                    [ngbTooltip]="dataItem?.allotment?.booking?.note"
                    container="body"
                  >
                    <i class="fal fa-sticky-note"></i>
                  </span>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                field="supplier.name"
                title="{{ 'SALES.SALES_VIEW.SUPPLIER' | translate }}"
                [columnMenu]="false"
                [width]="150"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div
                    class="d-inline-block text-truncate"
                    style="width: 150px"
                    [ngbTooltip]="dataItem?.supplier?.name"
                    container="body"
                  >
                    {{ dataItem.supplier?.name }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                field="allotment.booking.cancellation_deadline"
                title="{{ 'SALES.SALES_VIEW.CANCELLATION_DEADLINE' | translate }}"
                [columnMenu]="false"
                [width]="90"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ dataItem.allotment?.booking?.cancellation_deadline | date : env.pipeDateFormat }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                field="allotment.booking.property"
                title="{{ 'SALES.SALES_VIEW.BOOKING_STATUS' | translate }}"
                [columnMenu]="false"
                [width]="50"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <app-type-badge
                    [type]="dataItem?.allotment?.booking?.property"
                    style="width: 50px"
                    [ngbTooltip]="dataItem?.allotment?.booking?.property?.value"
                    container="body"
                  ></app-type-badge>

                  <div class="badge badge-dark" *ngIf="dataItem?.meta_front?.cancellationsCount">
                    {{ 'SALES.SALES_VIEW.CANCELLATION_FINISHED' | translate }}
                  </div>

                  <div
                    class="badge badge-dark"
                    *ngIf="dataItem?.meta_front?.cancellationsCount && !dataItem?.meta_front?.cancellationsCount"
                  >
                    {{ 'SALES.SALES_VIEW.CANCELLATION_IN_PROGRESS' | translate }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                field="ref_number"
                title="{{ 'SALES.SALES_VIEW.REF_NUMBER_SHORT' | translate }}"
                [columnMenu]="false"
                [width]="110"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <div
                    class="d-inline-block text-truncate"
                    style="width: 110px"
                    [ngbTooltip]="dataItem?.ref_number"
                    container="body"
                  >
                    {{ dataItem.ref_number }}
                  </div>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center ps-0 pe-0"
                field="check_in"
                title="{{ 'SALES.SALES_VIEW.CHECK_IN' | translate }}"
                [columnMenu]="false"
                [width]="90"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ dataItem?.check_in | date : env.pipeDateFormat }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                title="{{ 'SALES.SALES_VIEW.NIGHTS' | translate }}"
                field="nights"
                [columnMenu]="false"
                [width]="30"
              >
                <ng-template kendoGridHeaderTemplate>
                  <i class="fas fa-moon nights-ico"></i>
                </ng-template>

                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ dataItem.check_out | amDifference : dataItem.check_in : 'days' : true }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center ps-0 pe-0"
                field="check_out"
                title="{{ 'SALES.SALES_VIEW.CHECK_OUT' | translate }}"
                [columnMenu]="false"
                [width]="90"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ dataItem?.check_out | date : env.pipeDateFormat }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                field="type.value"
                title="{{ 'SALES.SALES_VIEW.TYPE' | translate }}"
                [columnMenu]="false"
                [width]="50"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <app-type-badge
                    [type]="dataItem.type"
                    style="width: 50px"
                    [ngbTooltip]="dataItem?.type?.value"
                    container="body"
                  ></app-type-badge>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center ps-0 pe-0"
                footerClass="text-center fw-bold "
                field="count"
                title="{{ 'SALES.SALES_VIEW.ROOM_COUNT' | translate }}"
                [columnMenu]="false"
                [width]="60"
              >
                <ng-template kendoGridFooterTemplate>
                  {{ dataItem.roomsTotal }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center ps-0 pe-0"
                footerClass="text-center fw-bold "
                field="people"
                title="{{ 'SALES.SALES_VIEW.PEOPLE' | translate }}"
                [columnMenu]="false"
                [width]="30"
              >
                <ng-template kendoGridHeaderTemplate>
                  <i class="fas fa-user"></i>
                </ng-template>

                <ng-template kendoGridFooterTemplate>
                  {{ dataItem.peopleTotal }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                field="meal_plan.value"
                title="{{ 'SALES.SALES_VIEW.MEAL_PLAN_SHORT' | translate }}"
                [width]="50"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  <app-type-badge [type]="dataItem.meal_plan"></app-type-badge>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                footerClass="text-center fw-bold "
                title="{{ 'SALES.SALES_VIEW.NET_PRICE' | translate }}"
                field="net_price"
                [width]="80"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ dataItem?.net_price | number : '1.2-2' }}
                  <app-currency-box [currency]="dataItem?.net_price_currency"></app-currency-box>

                  <app-currency-converter
                    class="d-block"
                    [fromCurrency]="dataItem?.net_price_currency"
                    [value]="dataItem?.net_price"
                  >
                  </app-currency-converter>
                </ng-template>

                <ng-template kendoGridFooterTemplate>
                  <!--  {{ offer?.meta_front?.selectedOffersLinesTotals?.net_price_eur || offer?.meta_front?.totals?.net_price_eur }} {{ 'DEFAULT_CURRENCY' | translate }}-->

                  {{ dataItem.netPriceTotal | number : '1.2-2' }}
                  {{ 'DEFAULT_CURRENCY' | translate }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                footerClass="text-center fw-bold "
                title="{{ 'SALES.SALES_VIEW.CLIENT_PRICE' | translate }}"
                field="price"
                [width]="80"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{ dataItem.price | number : '1.2-2' }}
                  {{ 'DEFAULT_CURRENCY' | translate }}
                </ng-template>

                <ng-template kendoGridFooterTemplate>
                  {{ dataItem.priceTotal | number : '1.2-2' }}
                  {{ 'DEFAULT_CURRENCY' | translate }}
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column
                class="text-center"
                headerClass="text-center"
                footerClass="text-center fw-bold "
                title="{{ 'SALES.SALES_VIEW.CLIENT_MARGIN' | translate }}"
                field="margin"
                [width]="80"
              >
                <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                  {{
                    dataItem.price - CurrenciesAdditionsService.toEUR(dataItem.net_price, dataItem.net_price_currency)
                      | number : '1.2-2'
                  }}
                  {{ 'DEFAULT_CURRENCY' | translate }}
                </ng-template>

                <ng-template kendoGridFooterTemplate>
                  {{ dataItem.marginTotal | number : '1.2-2' }}
                  {{ 'DEFAULT_CURRENCY' | translate }}
                </ng-template>
              </kendo-grid-column>
            </kendo-grid>
          </ng-template>
        </kendo-grid>

        <div class="modal-section-title">{{ 'SALES.WEB_OFFERS_FORM.SELECTED_OFFERS' | translate }}</div>

        <kendo-grid style="max-height: 400px" [columnMenu]="false" [data]="form.get('items').value">
          <kendo-grid-column [width]="32">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <div class="d-flex flex-column" *ngIf="form.get('items')?.value.length != 1">
                <button
                  *ngIf="rowIndex != 0"
                  (click)="moveUp(rowIndex)"
                  type="button"
                  class="btn btn-success btn-ico btn-sorting mb"
                  [ngbTooltip]="'SALES.WEB_OFFERS_FORM.MOVE_UP' | translate"
                  container="body"
                >
                  <i class="fal fa-arrow-up"></i>
                </button>

                <button
                  *ngIf="rowIndex + 1 != form.get('items')?.value.length"
                  (click)="moveDown(rowIndex)"
                  type="button"
                  class="btn btn-success btn-ico btn-sorting"
                  [ngbTooltip]="'SALES.WEB_OFFERS_FORM.MOVE_DOWN' | translate"
                  container="body"
                >
                  <i class="fal fa-arrow-down"></i>
                </button>
              </div>
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column [width]="40" field="number" title="{{ 'SALES.WEB_OFFERS_FORM.NUMBER' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              {{ rowIndex + 1 }}
            </ng-template>
          </kendo-grid-column>

          <kendo-grid-column
            field="web_offerable_item.name"
            title="{{ 'SALES.WEB_OFFERS_FORM.NAME' | translate }}"
          ></kendo-grid-column>

          <kendo-grid-column field="title" title="{{ 'SALES.WEB_OFFERS_FORM.TITLE' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
              <input
                type="text"
                class="form-control form-control-sm text-start"
                [(ngModel)]="dataItem.title"
                [ngModelOptions]="{ standalone: true }"
              />
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
      </div>

      <div class="col-sm-12">
        <label>{{ 'SALES.WEB_OFFERS_FORM.DESCRIPTION' | translate }}</label>
        <editor
          formControlName="description"
          [init]="{
            plugins: 'table ',
            base_url: '/assets/tinymce',
            suffix: '.min',
            height: 520
          }"
        ></editor>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="web-offers-form" [disabled]="form.invalid">
    {{ 'SALES.WEB_OFFERS_FORM.SAVE' | translate }}
  </button>
</div>
